import React from 'react';

import useCountryName from '@hooks/CachedLists/UseCountryName';

import NwFlagIcon from '@components/Gui/NwFlagIcon.js';

const CountryLabel = (props) => {
    const countryName = useCountryName(props.code);
    if (props.code) {
        return (
            <>
                {props.flag && <NwFlagIcon code={props.code.toLowerCase()} />}
                {props.usecode ? props.code : countryName}
            </>
        );
    } else {
        return <></>;
    }
};

export default CountryLabel;
